import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'mj-unit-user',
  templateUrl: 'unit-user.component.html',
  styleUrls: ['unit-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitUserComponent {
  @Input() user;
  @Output() resendInvitation = new EventEmitter();
  @Output() editUnitUser = new EventEmitter();
}
